/* tslint:disable */

declare var Object: any;
export interface SFPayProcessReportInterface {
  "id"?: number;
}

export class SFPayProcessReport implements SFPayProcessReportInterface {
  "id": number;
  constructor(data?: SFPayProcessReportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFPayProcessReport`.
   */
  public static getModelName() {
    return "SFPayProcessReport";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFPayProcessReport for dynamic purposes.
  **/
  public static factory(data: SFPayProcessReportInterface): SFPayProcessReport{
    return new SFPayProcessReport(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFPayProcessReport',
      plural: 'SFPayProcessReports',
      path: 'SFPayProcessReports',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFPayProcessReport.ts